import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PublicUser } from "@storyline/shared";
import type { RootState } from "@/src/common/redux/store";

type SessionState = {
	user: PublicUser | null;
	isHydrating: boolean;
	accessDenied: boolean;
};

const initialState: SessionState = {
	user: null,
	isHydrating: true,
	accessDenied: false,
};

const sessionSlice = createSlice({
	name: "session",
	initialState,
	reducers: {
		signIn: (state, action: PayloadAction<PublicUser>) => {
			state.user = action.payload;
			state.accessDenied = false;
		},
		signOut: (state) => {
			state.user = null;
		},
		denyAccess: (state) => {
			state.user = null;
			state.accessDenied = true;
		},
		clearAccessDenied: (state) => {
			state.accessDenied = false;
		},
		setHydrating: (state, action: PayloadAction<boolean>) => {
			state.isHydrating = action.payload;
		},
	},
});

export const { signIn, signOut, denyAccess, clearAccessDenied, setHydrating } = sessionSlice.actions;
export const sessionReducer = sessionSlice.reducer;

export const getSessionUser = (state: RootState): PublicUser | null => state.session.user;
export const getIsAuthenticated = (state: RootState): boolean => state.session.user !== null;
export const getIsHydrating = (state: RootState): boolean => state.session.isHydrating;
export const getAccessDenied = (state: RootState): boolean => state.session.accessDenied;
